/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useState, useMemo, useEffect } from 'react';
import { LuActivity, LuAlertTriangle, LuArrowDown, LuBeaker, LuBox, LuCheckCheck, LuCheckCircle, LuCheckCircle2, LuChevronDown, LuChevronRight, LuClipboardList, LuClock, LuDna, LuDownload, LuFileText, LuFlame, LuFlaskConical, LuHistory, LuLayers, LuPrinter, LuQrCode, LuShieldCheck, LuThermometer, LuZap } from 'react-icons/lu';
import { PlateReconcilationApi } from '../../../service/plateReconcilation';
import { userService as plateRelatedService } from "./../../../service/plateServices";
import { visualInspection } from '../../../service/visualinspection';
import { userService } from '../../../service/plateServices';
import { helperFunctions } from '../../../utils/helper';
import { DEFAULT_PAGE_SIZE } from '../../../constants/constants';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import HeaderSection from '../../common/headerSection';
import PageHeader from '../../common/pageHeader';



type Level = 'Batch' | 'Lot' | 'Plate';

type ActivityType =
   | 'Active Air Sampling'
   | 'Passive Air Sampling'
   | 'Contact Plate Monitoring'
   | 'Personnel Monitoring'
   | 'Surface Swab Monitoring'
   | 'Glove Monitoring'
   | 'Nitrogen Monitoring'
   | 'Compressed Air Monitoring'
   | 'Raw Material Testing'
   | 'Visual Inspection';

interface WorkflowNode {
   label: string;
   status: 'Completed' | 'In Progress' | 'Pending' | 'Rejected' | 'Skipped';
   timestamp?: string;
   user?: string;
   result?: string;
}

interface IncubationCycle {
   cycle: number;
   incubator: string;
   tempRange: string;
   start: string;
   end: string;
   duration: string;
   status: string;
}

interface LabTest {
   testNo: string;
   analyst: string;
   timestamp: string;
   count: number;
   status: string;
   remarks: string;
}

const PlateActivityReport3: React.FC = () => {

   const { t } = useTranslation();
   const [selectedBatch, setSelectedBatch] = useState('');
   const [selectedLot, setSelectedLot] = useState<string | null>('');
   const [selectedPlate, setSelectedPlate] = useState<string | null>('');
   const [selectedBatchId, setSelectedBatchId] = useState<any>(null);
   const [page, setPage] = useState(1);
   const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
   const [sort, setSort] = useState("id");
   const [order, setOrder] = useState("desc");
   const [keyword, setKeyword] = useState("");
   const [totalPages, setTotalPages] = useState(0);
   const [totalElements, setTotalElements] = useState(0);
   const [plateDetailsMap, setPlateDetailsMap] = useState<any>({});





   // Derived View Level
   const viewLevel = useMemo(() => {
      if (selectedBatch && selectedLot && selectedPlate) return 'PLATE';
      if (selectedBatch && selectedLot) return 'LOT';
      if (selectedBatch) return 'BATCH';
      return '';
   }, [selectedBatch, selectedLot, selectedPlate]);


   const [batches, setBatches] = useState<
      {
         value: string;
         label: string;
         batch_id: string;
      }[]
   >([]);

   const [lots, setLots] = useState<
      {
         value: string;
         label: string;
         batchCode: string;
         batchId: string;
      }[]
   >([]);

   const [plates, setplates] = useState<
      {
         value: string;
         label: string;
         batch_id: string;
      }[]
   >([]);

   const [batchDetails, setBatchDetails] = useState<any>(null);
   const [lotList, setLotList] = useState<any>(null);
   const [lotDetails, setLotDetails] = useState<any>(null);


   // const selectedLotData = lotList?.find(
   //    (lot: any) => lot.lot_code === selectedLot
   // );


   // Breadcrumb Logic
   const breadcrumbs = useMemo(() => {
      const list = [{ label: selectedBatch, level: 'BATCH' }];
      if (lotDetails) list.push({ label: lotDetails?.lot_code, level: 'LOT' });
      if (selectedPlate) list.push({ label: selectedPlate, level: 'PLATE' });
      return list;
   }, [selectedBatch, lotDetails, selectedPlate]);

   const isFloraEnabled = true;

   //batch code listing for table drop down
   const listPlateBatch = async () => {
      try {
         const response = await PlateReconcilationApi.listPlateBatch();

         if (response.status && response.statusCode === 200) {
            const rowData =
               response.data?.map((element: any) => ({
                  value: element.batch_number,
                  label: element.batch_number,
                  batch_id: element.id,
               })) || [];

            setBatches(rowData);
         }
      } catch (error) {
         console.error("Plate response", error);
      }
   };

   //lot code listing for table drop down
   const listLotCode = async (selectedBatch: any) => {
      try {
         const response = await visualInspection.listFilterLots(selectedBatch);

         if (response.status && response.statusCode === 200) {
            const rowData =
               response.data?.map((element: any) => ({
                  value: element.id,
                  label: element.lot_code,
                  batchCode: element.batch_no,
                  batchId: element.batch_id,
               })) || [];

            setLots(rowData);
         }
      } catch (error) {
         console.error("Plate response", error);
      }
   };

   //serial number listing for table drop down
   const listSerialNumber = async (batchId: any, lotId: any) => {
      try {
         const response = await plateRelatedService.listSerialNumber("", lotId, batchId);
         if (response.status && response.statusCode === 200) {
            try {
               if (Array.isArray(response.data) && response.data?.length > 0) {
                  let rowData: any = response.data.map(
                     (element: any, index: number) => {
                        return {
                           value: element.serial_number,
                           label: element.serial_number,
                           lot_id: element.lot_id,
                           batch_id: element.batch_id,
                           key: "serielNumber",
                        };
                     }
                  );
                  setplates(rowData);
               }
            } catch (error) {
               console.log(error);
            }
         } else {
            setplates([]);
         }
      } catch (error) {
         console.error("Plate response", error);
      }
   };

   const getBatchList = async (selectedBatch: any) => {
      try {
         const response = await PlateReconcilationApi.getBatchList(
            page,
            pageSize,
            selectedBatch,
            sort,
            order,
            "",
            ""
         );

         if (
            response.status &&
            response.statusCode === 200 &&
            response.data?.length > 0
         ) {
            const batch = response.data[0];

            setBatchDetails(batch);

            // Existing table code can remain unchanged
            let rowData = response.data.map((element: any, index: number) => {
               const plateBatchStatus = element.batch_status;
               let plateBatchType =
                  userService.plateBatchStatus(plateBatchStatus);

               return {
                  id: element.id,
                  slno: index + 1,
                  batch_code: element.batch_no,
                  batch_grn: element.batch_grn,
                  manufacturing_date: helperFunctions.formatDate(
                     element.manufacturing_date
                  ),
                  expiry_date: helperFunctions.formatDate(
                     element.expiry_date
                  ),
                  plateType: element.plate_size_type_name,
                  quantity: element.plate_count,
                  lot_count: element.lot_count,
                  tcm_status: element.tcm_status
                     ? element.tcm_status.charAt(0).toUpperCase() +
                     element.tcm_status.slice(1)
                     : "",
                  status: plateBatchType,
               };
            });

            // setBatchList(rowData);
         } else {
            setBatchDetails(null);
            // setBatchList([]);
         }
      } catch (error) {
         console.error(error);
      }
   };

   const ListLots = async (lot_id: any) => {
      setLotList([]);
      // setLoader(true);

      try {
         const response = await userService.ListLotsReconcilation(
            sort,
            keyword,
            batchDetails?.id,
            lot_id
         );

         if (
            response.status &&
            response.statusCode === 200 &&
            Array.isArray(response.data)
         ) {
            const rowData = response.data.map(
               (element: any, index: number) => ({
                  id: element.id,
                  slno: index + 1,

                  batch_no: element.batch_no,
                  lot_code: element.lot_code,

                  total: Number(element.plate_count || 0),
                  used: Number(element.used_plates_count || 0),
                  remaining: Number(element.remaining_plates_count || 0),

                  qr_generated: Number(element.qr_generated_plates || 0),

                  inspection_status:
                     element.inspection_status?.charAt(0).toUpperCase() +
                     element.inspection_status?.slice(1) || "",

                  failed_plate_count: Number(
                     element.failed_plate_count || 0
                  ),

                  remaining_plates_for_qr: Number(
                     element.remaining_plates_for_qr || 0
                  ),
               })
            );

            setLotList(rowData);
         } else {
            setLotList([]);
         }
      } catch (error) {
         console.error(error);
      } finally {
         // setLoader(false);
      }
   };

   const getPlateList = async (lotid: any, serialNumber: any) => {
      try {
         const response = await PlateReconcilationApi.getPlateListApi(lotid, serialNumber);
         if (response.status && response.statusCode === 200) {
            try {
               if (Array.isArray(response.data) && response.data?.length > 0) {
                  setTotalPages(response?.totalPages);
                  setTotalElements(response?.totalElements);
                  let rowData: any = response.data.map((element: any, index: number) => {
                     const statusNumber = parseInt(element.plate_status, 10);
                     let plateStatus = plateRelatedService.getPlateStatus(statusNumber);

                     // Function to get incubation order suffix
                     const getOrdinalSuffix = (num: number): string => {
                        if (num % 100 >= 11 && num % 100 <= 13) return "th"; // general approach for higher than two digits
                        switch (num % 10) {
                           case 1: return "st";
                           case 2: return "nd";
                           case 3: return "rd";
                           default: return "th";
                        }
                     };

                     if ((statusNumber === 12 || statusNumber === 13) && element.incubation_counter > 0) {
                        const suffix = getOrdinalSuffix(element.incubation_counter);
                        plateStatus = `${element.incubation_counter}${suffix} ${plateStatus}`;
                     }
                     return {
                        id: element.id,
                        slno: index + 1,
                        batch_number: element.batch_number,
                        serial_number: element.serial_number,
                        manufacturing_date: element.manufacturing_date,
                        production_schedule_name: element.production_schedule_name,
                        product_name: element.product_name,
                        expiry_date: element.expiry_date,
                        plate_type: element.plate_type,
                        exposure_details: element.exposure_details,
                        glove_monitoring_details: element.glove_monitoring_details,
                        finger_dab_details: element.finger_dab_details,
                        anaerobic_details: element.anaerobic_details,
                        nitrogen_monitoring_details: element.nitrogen_monitoring_details,
                        compressed_air_monitoring_details: element.compressed_air_monitoring_details,
                        plate_sampling_details: element.sampling_details,
                        raw_material_test_details: element.raw_materials_details,
                        surface_monitoring_details: element.surface_monitoring_details,
                        surface_monitoring_swab_details: element.surface_monitoring_swab_details,
                        incubation_details: element.incubation_details,
                        lab_details: element.lab_details,
                        autoclave_details: element.autoclave_details,
                        exception_details: element.exception_details,
                        deviation_details: element.deviation_details,
                        flora_details: element.flora_details,
                        lot_id: element.lot_id,
                        lot_code: element.lot_code,
                        master_activity_name: element.assigned_activity_name,
                        plate_status: plateStatus,
                        area_name: element.area_name,
                        location_name: element.assigned_location_name,
                        flora_required: element.flora_required
                     };
                  }
                  );
                  // setPlateDetails(rowData);
                  setPlateDetailsMap((prevState: any) => ({
                     ...prevState,
                     [lotDetails.id]: {
                        plateDetails: rowData,
                        totalPages: response.totalPages,
                        totalElements: response.totalElements
                     }
                  }));
                  // setLoader(false)
               }
            } catch (error) {
               console.log(error);
            }
         } else {
            // setPlateDetails([]);
            setPlateDetailsMap((prevState: any) => ({
               ...prevState,
               [lotDetails.id]: {
                  plateDetails: [],
                  totalPages: 0,
                  totalElements: 0
               }
            }));
            //   setLoader(false)
         }
      } catch (error) {
         console.error("Plate response", error);
      }
   };

   const selectedPlateData = useMemo(() => {
      return plateDetailsMap?.[lotDetails?.id]?.plateDetails?.find(
         (plate: any) => plate.serial_number === selectedPlate
      );
   }, [plateDetailsMap, lotDetails?.id, selectedPlate]);

   const plate = selectedPlateData;

   const lab = selectedPlateData?.lab_details?.[0];
   const flora = selectedPlateData?.flora_details?.[0];
   const autoclave = selectedPlateData?.autoclave_details?.[0];

   const activityDetails =
      plate?.glove_monitoring_details?.[0] ||
      plate?.exposure_details?.[0] ||
      plate?.anaerobic_details?.[0] ||
      plate?.nitrogen_monitoring_details?.[0] ||
      plate?.compressed_air_monitoring_details?.[0] ||
      plate?.finger_dab_details?.[0] ||
      plate?.surface_monitoring_details?.[0] ||
      plate?.surface_monitoring_swab_details?.[0] ||
      plate?.raw_material_test_details?.[0] ||
      plate?.plate_sampling_details?.[0] ||
      {};

   const activityType =
      plate?.glove_monitoring_details?.[0]
         ? 'Glove Monitoring'
         : plate?.exposure_details?.[0]
            ? 'Exposure Monitoring'
            : plate?.anaerobic_details?.[0]
               ? 'Anaerobic Monitoring'
               : plate?.nitrogen_monitoring_details?.[0]
                  ? 'Nitrogen Monitoring'
                  : plate?.compressed_air_monitoring_details?.[0]
                     ? 'Compressed Air Monitoring'
                     : plate?.finger_dab_details?.[0]
                        ? 'Personnel Monitoring'
                        : plate?.surface_monitoring_details?.[0]
                           ? 'Surface Monitoring'
                           : plate?.surface_monitoring_swab_details?.[0]
                              ? 'Surface Monitoring Swab'
                              : plate?.raw_material_test_details?.[0]
                                 ? 'Raw Material Test'
                                 : plate?.plate_sampling_details?.[0]
                                    ? 'Contact Plate Monitoring'
                                    : '';


   const incubations = (plate?.incubation_details || []).map(
      (inc: any, index: number) => {
         let duration = "-";

         if (inc.start_date_time && inc.end_date_time) {
            const start = new Date(inc.start_date_time).getTime();
            const end = new Date(inc.end_date_time).getTime();

            const diffMs = end - start;

            const hours = Math.floor(diffMs / (1000 * 60 * 60));
            const minutes = Math.floor(
               (diffMs % (1000 * 60 * 60)) / (1000 * 60)
            );

            duration = `${hours} h ${minutes} m`;
         }

         return {
            cycle: index + 1,
            incubator: inc.incubator_name,
            duration,
            start: inc.start_date_time,
            end: inc.end_date_time || "-",
            status: inc.end_date_time ? "Completed" : "Running",
         };
      }
   );

   const labTests = (plate?.lab_details || []).map((lab: any) => ({
      testNo: `LAB TEST ${lab.lab_order}`,
      analyst: lab.completed_by_user_name,
      timestamp: lab.completed_date_time,
      remarks: lab.test_remarks,
      count: lab.colony_count,
      approvedBy: lab.approver_name,
      approvedDate: lab.approved_date,
      status: lab.status,
      withinRange: lab.with_in_range
   }));

   const latestLab =
      plate?.lab_details?.length > 0
         ? [...plate.lab_details].sort(
            (a: any, b: any) =>
               Number(b.lab_order) - Number(a.lab_order)
         )[0]
         : null;

   const totalCFU = plate?.lab_details?.reduce(
      (sum: number, lab: any) =>
         sum + Number(lab.colony_count || 0),
      0
   );

   const latestIncubation =
      plate?.incubation_details?.[
      plate?.incubation_details?.length - 1
      ];

   const latestApproval =
      plate?.lab_details?.find(
         (lab: any) => lab.approved_user_id
      );

   const batchKpis = [
      {
         label: "Batch Code",
         val: batchDetails?.batch_no || selectedBatch,
         color: "blue",
      },
      {
         label: "Total Plates",
         val: batchDetails?.plate_count || 0,
         color: "orange",
      },
      {
         label: "Used Plates",
         val: batchDetails?.used_plates_count || 0,
         color: "emerald",
      },
      {
         label: "Remaining",
         val: batchDetails?.remaining_plates_count || 0,
         color: "orange",
      },
      {
         label: "Active Plates",
         val: batchDetails?.active_plates_count || 0,
         color: "blue",
      },
      {
         label: "Total Lots",
         val: batchDetails?.lot_count || 0,
         color: "blue",
      },
      {
         label: "Failed Plates",
         val: batchDetails?.total_failed_count || 0,
         color: "rose",
      },
      {
         label: "QA Status",
         val: batchDetails?.qa_approved_status_name || "-",
         color: "emerald",
      },
   ];

   const lotKpis = [
      {
         label: "Lot Code",
         val: lotDetails?.lot_code || "-",
         color: "purple",
      },
      {
         label: "Total Plates",
         val: lotDetails?.total || 0,
         color: "slate",
      },
      {
         label: "Used Plates",
         val: lotDetails?.used || 0,
         color: "emerald",
      },
      {
         label: "Remaining",
         val: lotDetails?.remaining || 0,
         color: "orange",
      },
      {
         label: "QR Generated",
         val: lotDetails?.qr_generated || 0,
         color: "blue",
      },
      {
         label: "Active Plates",
         val:
            (lotDetails?.used || 0) -
            (lotDetails?.failed_plate_count || 0),
         color: "blue",
      },
      {
         label: "Failed Plates",
         val: lotDetails?.failed_plate_count || 0,
         color: "emerald",
      },
      {
         label: "Inspection",
         val: lotDetails?.inspection_status || "-",
         color:
            lotDetails?.inspection_status === "Passed"
               ? "emerald"
               : "orange",
      },
   ]

   const plateKpis = [
      {
         label: 'Plate Number',
         val: selectedPlateData?.serial_number || '-',
         color: 'blue'
      },
      {
         label: 'Status',
         val: selectedPlateData?.plate_status || '-',
         color: 'amber'
      },
      {
         label: 'Activity',
         val: selectedPlateData?.master_activity_name || '-',
         color: 'blue'
      },
      {
         label: 'CFU Count',
         val: lab?.colony_count || '0',
         color: 'emerald'
      },
      {
         label: 'Alert Limit',
         val: lab?.alert_limit || '-',
         color: 'orange'
      },
      {
         label: 'Action Limit',
         val: lab?.action_limit || '-',
         color: 'rose'
      },
      {
         label: 'Flora',
         val: !flora
            ? '-'
            : flora.flora_status === "36"
               ? "Approved"
               : flora.flora_status === "37"
                  ? "Rejected"
                  : "Completed",
         color: 'blue'
      },
      {
         label: 'Autoclave',
         val:
            selectedPlateData?.autoclave_details?.length > 0
               ? 'Done'
               : 'Pending',
         color: 'emerald'
      }
   ]


   const workflowNodes = [
 
 
   // 2. Incubation cycles — one node per cycle
   ...incubations.map((inc: any) => ({
      label: `Incubation ${inc.cycle}`,
      timestamp: inc.start,
      result: inc.incubator || "-",
      // incubations map already sets status "Completed" | "Running"
      // normalise "Running" → "In Progress" to match WorkflowNode type
      status: inc.status === "Completed"
         ? "Completed"
         : "In Progress",
   })),
 
   // 3. Lab tests — one node per test, labelled with order number
   ...labTests.map((test: any) => ({
      label: test.testNo,           // e.g. "LAB TEST 1"
      timestamp: test.timestamp,
      result: `${test.count ?? 0} CFU`,
      // use the real status from the API; fall back to Completed if present
      // status: test.status === "22" ? "Completed" : "Pending",
      status: test?.status === "22"
         ? "Completed"
         : test?.status === "23"
         ? "Rejected"
         : test?.status === "21"
         ? "Pending":  "In Progress"
   })),
 
   // 4. Approval
   {
      label: "Approval",
      timestamp: latestApproval?.approved_date,
      result: latestApproval?.approver_name || "Awaiting Approval",
      status: latestApproval?.status === "22"
         ? "Completed"
         : latestApproval?.status === "23"
         ? "Rejected"
         : latestApproval?.status === "21"
         ? "Pending":  "In Progress"
   },

 
   // 5. Environmental Flora — only included when flora is enabled
   ...(flora
      ? [
         {
            label: "Environmental Flora",
            timestamp: flora?.created_date,
            result: flora?.genus_name || "Awaiting Analysis",
            status: flora
               ? (flora.flora_status === "36"
                  ? "Completed"                 // Approved
                  : flora.flora_status === "37"
                     ? "Rejected"               // Rejected
                     : "In Progress")           // recorded but pending decision
               : plate?.flora_required === "1"
                  ? "In Progress"               // required, not yet recorded
                  : "Pending",                  // not required / not started
         },
      ]
      : []),
 
   // 6. Final Disposition (Autoclave)
   {
      label: "Final Disposition",
      timestamp: autoclave?.start_time ?? null,
      result: autoclave?.location_name ?? null,
      status: autoclave?.end_time
         ? "Completed"
         : "Pending",
   },
 
];


   const calculateDaysRemaining = (expiryDate: string) => {
      const today = new Date();
      const expiry = new Date(expiryDate);

      const diffTime = expiry.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays > 0 ? diffDays : 0;
   };

   const getStatusColor = (status: string = "") => {
      const value = status.toUpperCase();

      if (value.includes("INPROGRESS")) {
         return "bg-blue-50 text-blue-600 border-blue-200";
      }

      if (
         value.includes("APPROVED") ||
         value.includes("COMPLETED")
      ) {
         return "bg-emerald-50 text-emerald-600 border-emerald-200";
      }

      if (value.includes("DISCARDED")) {
         return "bg-rose-50 text-rose-600 border-rose-200";
      }

      if (value.includes("NEW")) {
         return "bg-slate-50 text-slate-600 border-slate-200";
      }

      return "bg-gray-50 text-gray-600 border-gray-200";
   };

   const qrGenerated = batchDetails?.used_plates_count || 0;
   const totalPlates = batchDetails?.plate_count || 0;

   const generationRate =
      totalPlates > 0
         ? Math.round((qrGenerated / totalPlates) * 100)
         : 0;

   const expiryDays = batchDetails?.expiry_date
      ? calculateDaysRemaining(batchDetails.expiry_date)
      : 0;

   const isQaApproved =
      batchDetails?.qa_approved_status_name === "APPROVED";

   const inventoryHealthy =
      (batchDetails?.remaining_plates_count ?? 0) > 0
         ? "OPTIMAL"
         : "LOW";

   const isFullyQualified =
      isQaApproved &&
      (batchDetails?.remaining_plates_count ?? 0) >= 0;

   const utilization =
      lotDetails?.total > 0
         ? Math.round(
            (lotDetails.used / lotDetails.total) * 100
         )
         : 0;

   useEffect(() => {
      listPlateBatch();
   }, []);

   useEffect(() => {
      if (selectedBatch) {
         listLotCode(selectedBatch);
         getBatchList(selectedBatch);
      } else {
         setLots([]);
      }
   }, [selectedBatch]);

   useEffect(() => {
      if (selectedBatch && lotDetails?.id) {
         listSerialNumber(selectedBatch, lotDetails?.id);
      } else {
         setplates([]);
      }
   }, [selectedBatch, lotDetails]);

   useEffect(() => {
      if (batchDetails?.id) {
         ListLots("");
      }
   }, [batchDetails])

   useEffect(() => {
      const lotData = lotList?.find(
         (lot: any) => lot.id === selectedLot
      );

      setLotDetails(lotData)

   }, [selectedLot, lotList]);

   useEffect(() => {
      if (lotDetails?.id) {
         getPlateList(lotDetails.id, selectedPlate ? selectedPlate : "");
      }
   }, [lotDetails, selectedPlate]);




   return (
      <div>
         <HeaderSection />
         <PageHeader pageHeader={t('navbar.Plate Activity Report')} pageDescription={t('pageDescription.plateActivityReport.description')} />
         <div className="min-h-screen bg-[#F8FAFC] p-6 lg:p-8 font-sans selection:bg-blue-100 selection:text-blue-900">
            <div className="max-w-[1600px] mx-auto space-y-6">

               {/* Header Section */}
               <header className="bg-white p-6 rounded-[2.5rem] border border-slate-200/60 shadow-[0_8px_30px_rgb(0,0,0,0.02)] flex flex-col xl:flex-row xl:items-center justify-between gap-6 overflow-hidden relative">
                  <div className="absolute top-0 right-0 w-80 h-80 bg-blue-50/40 rounded-full blur-3xl -mr-40 -mt-40 pointer-events-none" />

                  <div className="relative z-10">
                     {/* <div className="flex items-center gap-2 text-[10px] font-black text-slate-300 uppercase tracking-[0.25em] mb-3">
                        {breadcrumbs.map((bc, i) => (
                           <React.Fragment key={i}>
                              {i > 0 && <LuChevronRight className="w-3 h-3 text-slate-200" />}
                              <span className={i === breadcrumbs.length - 1 ? "text-blue-600 bg-blue-50/50 px-2 py-0.5 rounded-md border border-blue-100/50" : ""}>{bc.label}</span>
                           </React.Fragment>
                        ))}
                     </div> */}

                     <div className="flex items-center gap-2 text-[10px] font-black text-slate-300 uppercase tracking-[0.25em] mb-3">
                        {breadcrumbs.map((bc, i) => (
                           <React.Fragment key={i}>
                              {i > 0 && bc.label && (
                                 <LuChevronRight className="w-3 h-3 text-slate-200" />
                              )}

                              {bc.label && (
                                 <span
                                    className={
                                       i === breadcrumbs.length - 1
                                          ? "text-blue-600 bg-blue-50/50 px-2 py-0.5 rounded-md border border-blue-100/50"
                                          : ""
                                    }
                                 >
                                    {bc.label}
                                 </span>
                              )}
                           </React.Fragment>
                        ))}
                     </div>
                     <div className="flex items-center gap-3">
                        <div>
                        <h1 className="text-2xl font-semibold text-slate-500 tracking-tighter">
                           Plate Traceability Report
                        </h1>
                        {/* <p className="mt-1 text-[14px] font-normal text-gray-600 leading-5">
                           {t('pageDescription.plateActivityReport.description')}
                        </p> */}
                        </div>

                        {viewLevel && (
                           <>
                           <span className="px-3 py-1 bg-slate-100 text-slate-500 text-[10px] font-black rounded-full uppercase tracking-widest border border-slate-200 whitespace-nowrap shrink-0">
                              {viewLevel} VIEW
                           </span>

                           <div className="w-2 h-2 rounded-full bg-emerald-500 shadow-[0_0_12px_rgba(16,185,129,0.5)] shrink-0" />
                           </>
                        )}

                     </div>
                  </div>

                  <div className="flex flex-wrap items-center gap-3 relative ">
                     <div className="flex flex-wrap gap-3 mr-4">
                        <div className="space-y-1">
                           <div style={{ display: "flex", flexDirection: "column" }}>
                              <label className="text-[9px] font-black text-slate-500 uppercase tracking-widest px-1">Batch</label>
                              <div >
                                 <Select
                                    options={batches}
                                    onChange={(e: any) => {
                                       setSelectedBatch(e?.value);
                                       setSelectedLot(null);
                                       setSelectedPlate(null);
                                    }}
                                    placeholder="Select Batch"
                                    isSearchable={true}
                                    isClearable
                                    value={batches.find((option: any) => option.value === selectedBatch) || null}
                                    name="batchCode"
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    classNames={{
                                       control: () =>
                                          "min-w-[200px] cursor-pointer",
                                    }}
                                    styles={{
                                       menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                       }),
                                    }}
                                 />
                              </div>
                           </div>

                        </div>
                        <div className="space-y-1">
                           <div style={{ display: "flex", flexDirection: "column" }}>
                              <label className="text-[9px] font-black text-slate-500 uppercase tracking-widest px-1">Lot</label>
                              <div >
                                 <Select
                                    options={lots}
                                    onChange={(e: any) => {
                                       setSelectedLot(e?.value);
                                       setSelectedPlate(null);
                                    }}
                                    placeholder="Select Lot"
                                    isSearchable={true}
                                    isClearable
                                    value={lots.find((option: any) => option.value === selectedLot) || null}
                                    name="lotCode"
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    classNames={{
                                       control: () =>
                                          "min-w-[200px] cursor-pointer",
                                    }}
                                    styles={{
                                       menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                       }),
                                    }}
                                 />
                              </div>
                           </div>
                           
                        </div>
                        <div className="space-y-1">
                           <div style={{ display: "flex", flexDirection: "column" }}>
                              <label className="text-[9px] font-black text-slate-500 uppercase tracking-widest px-1">Plate</label>
                              <div >
                                 <Select
                                    options={plates}
                                    onChange={(e: any) => {
                                       setSelectedPlate(e?.value);
                                    }}
                                    placeholder="Select Plate"
                                    isSearchable={true}
                                    isClearable
                                    value={plates.find((option: any) => option.value === selectedPlate) || null}
                                    name="plateCode"
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    classNames={{
                                       control: () =>
                                          "min-w-[200px] cursor-pointer",
                                    }}
                                    styles={{
                                       menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                       }),
                                    }}
                                 />
                              </div>
                           </div>

                           
                        </div>
                     </div>

                     {/* <div className="flex gap-2 pt-4 xl:pt-0">
                        <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 hover:border-slate-300 transition-all shadow-sm active:scale-95">
                           <LuPrinter className="w-3.5 h-3.5" /> Print
                        </button>
                        <button className="flex items-center gap-2 px-5 py-2.5 bg-[#0F172A] rounded-xl text-[10px] font-black uppercase tracking-widest text-white hover:bg-blue-600 transition-all shadow-xl shadow-blue-900/10 active:scale-95">
                           <LuDownload className="w-3.5 h-3.5" /> Export
                        </button>
                     </div> */}
                  </div>
               </header>
               {/* Dynamic State Rendering */}
               {/* <AnimatePresence mode="wait"> */}
               {viewLevel === 'BATCH' && (
                  <div>
                     {/* Batch Level Content */}
                     <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
                        {batchKpis.map((kpi, idx) => (
                           <KpiCard
                              key={idx}
                              label={kpi.label}
                              val={kpi.val}
                              color={kpi.color}
                           />
                        ))}
                     </div>

                     <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-4">
                        {/* Batch Summary Header */}
                        <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-8 relative overflow-hidden group lg:col-span-1">
                           <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] flex items-center gap-2.5 border-b border-slate-50 pb-1">
                              <LuBox className="w-4 h-4 text-orange-500" />
                              Batch Summary
                           </h3>

                           <div className="grid grid-cols-2 gap-x-8 gap-y-5">
                              <DetailEntry
                                 l="Batch Code"
                                 v={batchDetails?.batch_no || selectedBatch}
                              />

                              <DetailEntry
                                 l="Batch GRN"
                                 v={batchDetails?.batch_grn || "-"}
                              />

                              <DetailEntry
                                 l="Plate Type"
                                 v={batchDetails?.plate_size_type_name || "-"}
                              />

                              <DetailEntry
                                 l="Mfg Date"
                                 v={
                                    batchDetails?.manufacturing_date
                                       ? helperFunctions.formatDate(batchDetails.manufacturing_date)
                                       : "-"
                                 }
                              />

                              <div className="space-y-1.5 group/entry">
                                 <p className="text-[9px] font-black text-slate-500 uppercase tracking-widest group-hover/entry:text-blue-400 transition-colors">
                                    Expiry Date
                                 </p>

                                 <p className="text-[11px] font-black text-rose-500 border-b border-slate-50 pb-2 group-hover/entry:border-blue-50 transition-colors">
                                    {batchDetails?.expiry_date
                                       ? helperFunctions.formatDate(batchDetails.expiry_date)
                                       : "-"}
                                 </p>

                                 <p className="text-[9px] font-black text-rose-400 bg-rose-50 px-2 py-0.5 rounded-md border border-rose-100 inline-block">
                                    {batchDetails?.expiry_date
                                       ? `${calculateDaysRemaining(batchDetails.expiry_date)} Days Remaining`
                                       : "N/A"}
                                 </p>
                              </div>

                              <DetailEntry
                                 l="QA Status"
                                 v={batchDetails?.qa_approved_status_name || "-"}
                              />
                           </div>
                        </div>

                        {/* Inventory & QR Summary */}
                        <div className="xl:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
                           <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-6">
                              <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] flex items-center gap-2 border-b border-slate-50 pb-1">
                                 <LuLayers className="w-4 h-4 text-blue-500" /> Inventory Summary
                              </h3>
                              <div className="space-y-4">
                                 <SummaryItem
                                    l="Total Plate Count"
                                    v={batchDetails?.plate_count || 0}
                                 />

                                 <SummaryItem
                                    l="Lot Assigned Plates"
                                    v={batchDetails?.lot_assigned_plate_count || 0}
                                 />

                                 <SummaryItem
                                    l="Remaining For Lot Assignment"
                                    v={batchDetails?.remaining_for_lot_assign || 0}
                                 />

                                 <SummaryItem
                                    l="Available For QR Generation"
                                    v={batchDetails?.remaining_plates_for_qr_count || 0}
                                 />
                              </div>
                           </div>
                           <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-6">
                              <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] flex items-center gap-2 border-b border-slate-50 pb-1">
                                 <LuQrCode className="w-4 h-4 text-purple-500" /> QR Generation Summary
                              </h3>
                              <div className="space-y-4">
                                 <SummaryItem
                                    l="QR Generated Plates"
                                    v={batchDetails?.used_plates_count || 0}
                                 />

                                 <SummaryItem
                                    l="Newly Generated QR Plates"
                                    v={batchDetails?.active_plates_count || 0}
                                 />

                                 <SummaryItem
                                    l="Available For QR Generation"
                                    v={batchDetails?.remaining_plates_for_qr_count || 0}
                                 />

                                 <div className="pt-2">
                                    <div className="flex justify-between items-end mb-2">
                                       <span className="text-[10px] font-black text-slate-400 uppercase">
                                          Generation Rate
                                       </span>

                                       <span className="text-sm font-black text-blue-600">
                                          {generationRate}%
                                       </span>
                                    </div>

                                    <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
                                       <div
                                          className="h-full bg-blue-500 rounded-full"
                                          style={{ width: `${generationRate}%` }}
                                       />
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     {/* Lot Distribution Table */}
                     <div className="bg-white p-8 rounded-[3rem] border border-slate-200/60 shadow-sm space-y-6 mt-4">
                        <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] flex items-center gap-3 border-b border-slate-50 pb-1">
                           <LuClipboardList className="w-4 h-4 text-purple-500" /> Lot Distribution Registry
                        </h3>
                        <div className="overflow-x-auto">
                           <table className="w-full text-left border-collapse">
                              <thead>
                                 <tr className="text-[9px] font-black text-slate-400 uppercase tracking-widest bg-slate-50/50 rounded-xl overflow-hidden">
                                    <th className="pl-6 py-4">Lot Code</th>
                                    <th className="py-4">Total Plates</th>
                                    <th className="py-4">Utilization</th>
                                    <th className="py-4">Remaining</th>
                                    <th className="py-4">QR Generated</th>
                                    <th className="py-4">Status</th>
                                    <th className="py-4">Action</th>
                                    {/* <th className="py-4 pr-6 text-right">Action</th> */}
                                 </tr>
                              </thead>
                              <tbody className="divide-y divide-slate-50">
                                 {lotList?.map((item: any) => (
                                    <tr
                                       key={item.id}
                                       className="group hover:bg-slate-50/50 transition-all"
                                    >
                                       <td className="pl-6 py-4 font-black text-slate-800">
                                          {item.lot_code}
                                       </td>

                                       <td className="py-4 text-xs font-bold text-slate-500">
                                          {item.total}
                                       </td>

                                       <td className="py-4">
                                          <div className="flex flex-col gap-1 w-32">
                                             <span className="text-[10px] font-black text-slate-600">
                                                {item.used}/{item.total} Used
                                             </span>

                                             <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
                                                <div
                                                   className={`h-full rounded-full ${(item.used / item.total) * 100 > 80
                                                      ? "bg-emerald-500"
                                                      : "bg-blue-500"
                                                      }`}
                                                   style={{
                                                      width: `${item.total
                                                         ? (item.used / item.total) * 100
                                                         : 0
                                                         }%`,
                                                   }}
                                                />
                                             </div>
                                          </div>
                                       </td>

                                       <td className="py-4 text-xs font-bold text-orange-500">
                                          {item.remaining}
                                       </td>

                                       <td className="py-4 text-xs font-bold text-slate-600">
                                          {item.qr_generated}
                                       </td>

                                       <td className="py-4">
                                          <span
                                             className={`px-2 py-0.5 rounded-lg text-[9px] font-black uppercase tracking-widest border ${item.inspection_status === "Passed"
                                                ? "bg-emerald-50 text-emerald-600 border-emerald-100"
                                                : item.inspection_status === "Pending"
                                                   ? "bg-rose-50 text-yellow-600 border-rose-100"
                                                : item.inspection_status === "Failed"
                                                   ? "bg-rose-50 text-red-600 border-rose-100"
                                                   : "bg-blue-50 text-blue-600 border-blue-100"
                                                }`}
                                          >
                                             {item.inspection_status}
                                          </span>
                                       </td>

                                       <td className="py-4 text-[9px] font-black text-blue-600 uppercase tracking-widest hover:underline cursor-pointer"
                                          onClick={() => setSelectedLot(item.id)}
                                       >
                                          View Lot Details
                                       </td>
                                    </tr>
                                 ))}
                              </tbody>
                              {/* <tbody className="divide-y divide-slate-50">
                                 {[
                                    { lot: 'LOT-M-99A', used: 84, total: 100 },
                                    { lot: 'LOT-M-99B', used: 42, total: 100 },
                                    { lot: 'LOT-M-99C', used: 10, total: 100 }
                                 ].map((item, idx) => (
                                    <tr key={idx} className="group hover:bg-slate-50/50 transition-all">
                                       <td className="pl-6 py-4 font-black text-slate-800">{item.lot}</td>
                                       <td className="py-4 text-xs font-bold text-slate-500">{item.total}</td>
                                       <td className="py-4">
                                          <div className="flex flex-col gap-1 w-32">
                                             <span className="text-[10px] font-black text-slate-600">{item.used}/{item.total} Used</span>
                                             <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
                                                <div className={`h-full rounded-full ${item.used > 80 ? 'bg-emerald-500' : 'bg-blue-500'}`} style={{ width: `${(item.used / item.total) * 100}%` }} />
                                             </div>
                                          </div>
                                       </td>
                                       <td className="py-4 text-xs font-bold text-orange-500">{item.total - item.used}</td>
                                       <td className="py-4 text-xs font-bold text-slate-600">{item.used}</td>
                                       <td className="py-4">
                                          <span className="px-2 py-0.5 rounded-lg text-[9px] font-black bg-emerald-50 text-emerald-600 border border-emerald-100 uppercase tracking-widest">QUALIFIED</span>
                                       </td>
                                       <td className="py-4 pr-6 text-right">
                                          <button
                                             onClick={() => setSelectedLot(item.lot)}
                                             className="text-[9px] font-black text-blue-600 uppercase tracking-widest hover:underline"
                                          >View Lot Details</button>
                                       </td>
                                    </tr>
                                 ))}
                              </tbody> */}
                           </table>
                        </div>
                     </div>

                     {/* Batch Health Card */}
                     <div className="bg-[#0F172A] p-6 rounded-[2rem] text-white flex flex-col md:flex-row items-center justify-between gap-6 shadow-xl shadow-slate-900/10 mt-4">

                        <div className="flex items-center gap-8">
                           <div className="flex flex-col">

                              <span className="text-[8px] font-black text-slate-500 uppercase tracking-widest mb-2">
                                 Global Health Index
                              </span>

                              <div className="flex items-center gap-3">

                                 <CompactHealthBadge
                                    l="QA"
                                    v={batchDetails?.qa_approved_status_name || "PENDING"}
                                    c={
                                       isQaApproved
                                          ? "text-emerald-400 bg-emerald-400/10"
                                          : "text-rose-400 bg-rose-400/10"
                                    }
                                 />

                                 <CompactHealthBadge
                                    l="Inventory Healthy"
                                    v={inventoryHealthy}
                                    c={
                                       inventoryHealthy === "OPTIMAL"
                                          ? "text-blue-400 bg-blue-400/10"
                                          : "text-orange-400 bg-orange-400/10"
                                    }
                                 />

                                 <CompactHealthBadge
                                    l="Expiry Valid"
                                    v={`${expiryDays}D`}
                                    c={
                                       expiryDays > 30
                                          ? "text-emerald-400 bg-emerald-400/10"
                                          : expiryDays > 0
                                             ? "text-orange-400 bg-orange-400/10"
                                             : "text-rose-400 bg-rose-400/10"
                                    }
                                 />
                              </div>
                           </div>
                        </div>

                        <div className="flex items-center gap-4 bg-white/5 px-6 py-4 rounded-2xl border border-white/10">

                           <LuCheckCircle2 className="w-5 h-5 text-emerald-400" />

                           <p className="text-sm font-black text-white uppercase tracking-tight">
                              {isFullyQualified
                                 ? "FULLY QUALIFIED BATCH"
                                 : "NOT FULLY QUALIFIED"}
                           </p>
                        </div>

                     </div>

                  </div>
               )}

               {viewLevel === 'LOT' && (
                  <div>
                     {/* Lot Level Content */}
                     <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
                        {lotKpis.map((kpi, idx) => (
                           <KpiCard
                              key={idx}
                              label={kpi.label}
                              val={kpi.val}
                              color={kpi.color}
                           />
                        ))}
                     </div>

                     <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mt-4">
                        {/* Lot Summary Card */}
                        <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-8 lg:col-span-1">
                           <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] flex items-center gap-2 border-b border-slate-50 pb-4">
                              <LuClipboardList className="w-4 h-4 text-purple-500" /> Lot Summary
                           </h3>
                           <div className="grid grid-cols-2 gap-x-8 gap-y-5">
                              <DetailEntry
                                 l="Lot Code"
                                 v={lotDetails?.lot_code || "-"}
                              />

                              <DetailEntry
                                 l="Batch Code"
                                 v={lotDetails?.batch_no || batchDetails?.batch_no || "-"}
                              />

                              <DetailEntry
                                 l="Lot Size"
                                 v={`${lotDetails?.total || 0} Plates`}
                              />

                              <DetailEntry
                                 l="Inspection"
                                 v={lotDetails?.inspection_status || "-"}
                              />
                           </div>
                        </div>

                        {/* Utilization Card */}
                        <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-6 lg:col-span-1">
                           <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] flex items-center gap-2 border-b border-slate-50 pb-4">
                              <LuZap className="w-4 h-4 text-amber-500" />
                              Utilization Info
                           </h3>

                           <div className="space-y-6">
                              <div className="flex justify-between items-end">
                                 <p className="text-[2rem] font-black text-slate-800 leading-none">
                                    {utilization}
                                    <span className="text-sm font-bold text-slate-400 ml-1">
                                       %
                                    </span>
                                 </p>

                                 <span
                                    className={`text-[10px] font-black uppercase tracking-widest px-2 py-0.5 rounded-md ${utilization >= 80
                                       ? "bg-emerald-50 text-emerald-500"
                                       : utilization >= 50
                                          ? "bg-amber-50 text-amber-500"
                                          : "bg-rose-50 text-rose-500"
                                       }`}
                                 >
                                    {utilization >= 80
                                       ? "High Usage"
                                       : utilization >= 50
                                          ? "Moderate Usage"
                                          : "Low Usage"}
                                 </span>
                              </div>

                              <div className="space-y-2">
                                 <div className="flex justify-between text-[9px] font-black text-slate-400 uppercase tracking-widest">
                                    <span>Progress</span>

                                    <span>
                                       {lotDetails?.used || 0}/
                                       {lotDetails?.total || 0} Plates
                                    </span>
                                 </div>

                                 <div className="h-3 bg-slate-100 rounded-full overflow-hidden p-0.5 border border-slate-200/50">
                                    <div
                                       className="h-full bg-blue-500 rounded-full shadow-[0_0_8px_rgba(59,130,246,0.3)] transition-all duration-1000"
                                       style={{ width: `${utilization}%` }}
                                    />
                                 </div>
                              </div>
                           </div>
                        </div>


                        <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-8 lg:col-span-1">
                           <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] flex items-center gap-2 border-b border-slate-50 pb-4">
                              <LuBox className="w-4 h-4 text-slate-400" />
                              Batch Info
                           </h3>

                           <div className="grid grid-cols-2 gap-x-8 gap-y-5">
                              <DetailEntry
                                 l="Batch Code"
                                 v={batchDetails?.batch_no || "-"}
                              />

                              <DetailEntry
                                 l="Plate Type"
                                 v={batchDetails?.plate_size_type_name || "-"}
                              />

                              <DetailEntry
                                 l="Expiry Date"
                                 v={
                                    batchDetails?.expiry_date
                                       ? helperFunctions.formatDate(
                                          batchDetails.expiry_date
                                       )
                                       : "-"
                                 }
                              />

                              <DetailEntry
                                 l="QA Status"
                                 v={batchDetails?.tcm_status || "-"}
                              />
                           </div>
                        </div>

                        <div className="bg-[#0F172A] p-8 rounded-[2.5rem] text-white lg:col-span-1">
                           <h3 className="text-[10px] font-black text-slate-500 uppercase tracking-widest border-b border-white/5 pb-4 mb-6">
                              Lot Status Card
                           </h3>

                           <div className="space-y-4">
                              <SummaryItemLight
                                 l="Inspection Status"
                                 v={lotDetails?.inspection_status || "-"}
                              />

                              <SummaryItemLight
                                 l="Remaining For QR"
                                 v={
                                    lotDetails?.remaining_plates_for_qr || 0
                                 }
                              />

                              <SummaryItemLight
                                 l="Failed Plates"
                                 v={
                                    lotDetails?.failed_plate_count || 0
                                 }
                              />

                              <div className="pt-4 flex justify-between items-end border-t border-white/5">
                                 <div>
                                    <p className="text-[9px] font-black text-slate-500 uppercase">
                                       System Integrity
                                    </p>

                                    <p
                                       className={`text-xl font-black ${lotDetails?.inspection_status ===
                                          "Passed"
                                          ? "text-emerald-400"
                                          : "text-amber-400"
                                          }`}
                                    >
                                       {lotDetails?.inspection_status?.toUpperCase() ||
                                          "-"}
                                    </p>
                                 </div>

                                 <LuShieldCheck className="w-10 h-10 text-emerald-500/20" />
                              </div>
                           </div>
                        </div>
                     </div>

                     {/* Plates in Lot Table */}
                     <div className="bg-white p-8 rounded-[3rem] border border-slate-200/60 shadow-sm space-y-6 mt-4">
                        <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] flex items-center gap-3 border-b border-slate-50 pb-1">
                           <LuFlaskConical className="w-4 h-4 text-blue-500" /> Plates In Traceability Registry
                        </h3>
                        <div className="overflow-x-auto">
                           <table className="w-full text-left border-collapse">
                              <thead>
                                 <tr className="text-[9px] font-black text-slate-400 uppercase tracking-widest bg-slate-50/50 rounded-xl overflow-hidden">
                                    <th className="pl-6 py-4">Plate Number</th>
                                    <th className="py-4">Activity Type</th>
                                    <th className="py-4">Current Stage</th>
                                    <th className="py-4">Status</th>
                                    {/* <th className="py-4">Count</th> */}
                                    <th className="py-4">Action</th>
                                 </tr>
                              </thead>
                              <tbody className="divide-y divide-slate-50">
                                 {(plateDetailsMap[lotDetails?.id]?.plateDetails || []).map(
                                    (plt: any, idx: number) => (
                                       <tr
                                          key={plt.id}
                                          className="group hover:bg-slate-50/50 transition-all"
                                       >
                                          <td className="pl-6 py-4 font-black text-slate-800">
                                             {plt.serial_number}
                                          </td>

                                          <td className="py-4 text-[10px] font-bold text-slate-500 uppercase tracking-tight">
                                             {plt.master_activity_name}
                                          </td>

                                          <td className="py-4 text-[11px] font-black text-slate-700">
                                             {plt.plate_status}
                                          </td>

                                          <td className="py-4">
                                             <span
                                                className={`px-2 py-0.5 rounded-lg text-[9px] font-black border uppercase tracking-widest ${getStatusColor(
                                                   plt.plate_status
                                                )}`}
                                             >
                                                {plt.plate_status}
                                             </span>
                                          </td>

                                          {/* <td className="py-4 font-black text-slate-800">
                                             {plt.flora_required ? "Yes" : "No"}
                                          </td> */}

                                          <td
                                             className="py-4 text-[9px] font-black text-blue-600 uppercase tracking-widest hover:underline cursor-pointer"
                                             onClick={() => setSelectedPlate(plt.serial_number)}
                                          >
                                             Trace Plate
                                          </td>
                                       </tr>
                                    )
                                 )}
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
               )}

               {viewLevel === 'PLATE' && (
                  <div>
                     {/* Batch & Lot Summary Row */}
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Batch Info */}
                        <div className="bg-white p-6 rounded-[2.25rem] border border-slate-200/60 shadow-sm space-y-4">
                           <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] border-b border-slate-50 pb-3 flex items-center gap-2">
                              <LuBox className="w-4 h-4 text-orange-500" /> Batch Details
                           </h3>
                           <div className="grid grid-cols-2 gap-4">
                              <DetailEntry l="Batch Code" v={batchDetails?.batch_no || selectedBatch} />
                              <DetailEntry l="Plate Type" v={batchDetails?.plate_size_type_name || "-"} />
                              <DetailEntry l="QA Status" v={batchDetails?.qa_approved_status_name || "-"} />
                              <DetailEntry l="Expiry" v={batchDetails?.expiry_date
                                 ? `${calculateDaysRemaining(batchDetails.expiry_date)} Days Remaining`
                                 : "N/A"} />
                           </div>
                        </div>
                        {/* Lot Info */}
                        <div className="bg-white p-6 rounded-[2.25rem] border border-slate-200/60 shadow-sm space-y-4">
                           <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] border-b border-slate-50 pb-3 flex items-center gap-2">
                              <LuClipboardList className="w-4 h-4 text-purple-500" /> Lot Details
                           </h3>
                           <div className="grid grid-cols-2 gap-4">
                              <DetailEntry l="Lot Code" v={lotDetails?.lot_code || selectedLot} />
                              <DetailEntry l="Lot Size" v={`${lotDetails?.total || 0} Plates`} />
                              <DetailEntry l="Utilization" v={String(utilization)} />
                              <DetailEntry l="Status" v={lotDetails?.inspection_status || "-"} />
                           </div>
                        </div>
                     </div>

                     {/* Plate Level KPIs */}
                     <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4 mt-4">
                        {/* {[
                           { label: 'Plate Number', val: selectedPlate!, color: 'blue' },
                           { label: 'Status', val: 'Incubating', color: 'amber' },
                           { label: 'Activity', val: activityType, color: 'blue' },
                           { label: 'CFU Count', val: '0', color: 'emerald' },
                           { label: 'Alert Limit', val: '3', color: 'orange' },
                           { label: 'Action Limit', val: '5', color: 'rose' },
                           { label: 'Flora', val: 'Negative', color: 'slate' },
                           { label: 'Autoclave', val: 'Done', color: 'emerald' }
                        ].map((kpi, idx) => (
                           <KpiCard key={idx} label={kpi.label} val={kpi.val} color={kpi.color} />
                        ))} */}
                        {plateKpis.map((kpi, idx) => (
                           <KpiCard
                              key={idx}
                              label={kpi.label}
                              val={kpi.val}
                              color={kpi.color}
                           />
                        ))}
                     </div>

                     {/* Dynamic Workflow Timeline */}
                     <div className="bg-white p-8 rounded-[3rem] border border-slate-200/60 shadow-sm space-y-8 overflow-hidden relative mt-4">
                        <div className="flex items-center justify-between border-b border-slate-50 pb-1">
                           <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.3em] flex items-center gap-3">
                              <LuActivity className="w-4 h-4 text-emerald-500" />
                              Lifecycle Traceability Timeline
                           </h3>

                           <div className="flex items-center gap-6">
                              <StatusLegendDot
                                 l="Completed"
                                 c="bg-emerald-500 shadow-[0_0_10px_rgba(16,185,129,0.3)]"
                              />
                              <StatusLegendDot
                                 l="Current"
                                 c="bg-blue-500 shadow-[0_0_10px_rgba(59,130,246,0.3)]"
                              />
                              <StatusLegendDot
                                 l="Pending"
                                 c="bg-slate-200"
                              />
                              <StatusLegendDot
                                 l="Warning"
                                 c="bg-orange-500 animate-pulse"
                              />
                           </div>
                        </div>

                        <div className="relative pt-10 pb-16 overflow-x-auto scrollbar-hide">
                           <div className="absolute top-[52px] left-8 right-8 h-1 bg-slate-100 z-0" />

                           <div className="relative z-10 flex min-w-[1400px] justify-between px-10">
                              {workflowNodes.length > 0 ? (
                                 workflowNodes.map((node, idx) => (
                                    <WorkflowNodeItem
                                       key={idx}
                                       node={node}
                                       idx={idx}
                                       total={workflowNodes.length}
                                       nextStatus={workflowNodes[idx + 1]?.status}
                                    />
                                 ))
                              ) : (
                                 <div className="w-full text-center py-10 text-slate-400">
                                    No lifecycle records available
                                 </div>
                              )}
                           </div>
                        </div>
                     </div>

                     {/* Lifecycle Sections in Order */}
                     <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mt-4">
                        <div className="xl:col-span-8 space-y-6">
                           {/* 1. Activity Details */}
                           <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-8">
                              <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] border-b border-slate-50 pb-1">
                                 Phase 01: Activity Capture (<span className="text-blue-600">{activityType}</span>)
                              </h3>
                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-8 gap-x-12">

                                 {activityType === "Glove Monitoring" && (
                                    <>
                                       <DetailEntry
                                          l="Location"
                                          v={activityDetails?.location_name || "-"}
                                       />

                                       <DetailEntry
                                          l="Started By"
                                          v={`${activityDetails?.started_by_user_firstname || "-"} ${activityDetails?.started_by_user_lastname || "-"
                                             }`}
                                       />

                                       <DetailEntry
                                          l="Start Time"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.start_date_time,
                                             true
                                          )}
                                       />
                                    </>
                                 )}

                                 {activityType === "Exposure Monitoring" && (
                                    <>
                                       <DetailEntry
                                          l="Exposed Area"
                                          v={activityDetails?.exposure_area_name || "-"}
                                       />

                                       <DetailEntry
                                          l="Exposed By"
                                          v={`${activityDetails?.created_by_first_name || "-"} ${activityDetails?.created_by_last_name || "-"
                                             }`}
                                       />

                                       <DetailEntry
                                          l="Exposed Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.start_date_time,
                                             true
                                          )}
                                       />

                                       <DetailEntry
                                          l="Collected By"
                                          v={`${activityDetails?.updated_by_first_name || "-"} ${activityDetails?.updated_by_last_name || "-"
                                             }`}
                                       />

                                       <DetailEntry
                                          l="Collected Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.end_date_time,
                                             true
                                          )}
                                       />
                                    </>
                                 )}

                                 {activityType === "Anaerobic Monitoring" && (
                                    <>
                                       <DetailEntry l="Area" v={plate?.area_name || "-"} />

                                       <DetailEntry
                                          l="Exposed By"
                                          v={`${activityDetails?.created_by_first_name || "-"} ${activityDetails?.created_by_last_name || "-"
                                             }`}
                                       />

                                       <DetailEntry
                                          l="Exposed Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.start_date_time,
                                             true
                                          )}
                                       />

                                       <DetailEntry
                                          l="Collected By"
                                          v={`${activityDetails?.updated_by_first_name || "-"} ${activityDetails?.updated_by_last_name || "-"
                                             }`}
                                       />

                                       <DetailEntry
                                          l="Collected Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.end_date_time,
                                             true
                                          )}
                                       />
                                    </>
                                 )}

                                 {activityType === "Nitrogen Monitoring" && (
                                    <>
                                       <DetailEntry l="Area" v={plate?.area_name || "-"} />

                                       <DetailEntry
                                          l="Exposed By"
                                          v={`${activityDetails?.created_by_first_name || "-"} ${activityDetails?.created_by_last_name || "-"
                                             }`}
                                       />

                                       <DetailEntry
                                          l="Exposed Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.start_date_time,
                                             true
                                          )}
                                       />

                                       <DetailEntry
                                          l="Collected By"
                                          v={`${activityDetails?.updated_by_first_name || "-"} ${activityDetails?.updated_by_last_name || "-"
                                             }`}
                                       />

                                       <DetailEntry
                                          l="Collected Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.end_date_time,
                                             true
                                          )}
                                       />
                                    </>
                                 )}

                                 {activityType === "Compressed Air Monitoring" && (
                                    <>
                                       <DetailEntry l="Area" v={plate?.area_name || "-"} />

                                       <DetailEntry
                                          l="Exposed By"
                                          v={`${activityDetails?.created_by_first_name || "-"} ${activityDetails?.created_by_last_name || "-"
                                             }`}
                                       />

                                       <DetailEntry
                                          l="Exposed Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.start_date_time,
                                             true
                                          )}
                                       />

                                       <DetailEntry
                                          l="Collected By"
                                          v={`${activityDetails?.updated_by_first_name || "-"} ${activityDetails?.updated_by_last_name || "-"
                                             }`}
                                       />

                                       <DetailEntry
                                          l="Collected Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.end_date_time,
                                             true
                                          )}
                                       />
                                    </>
                                 )}

                                 {activityType === "Personnel Monitoring" && (
                                    <>
                                       <DetailEntry
                                          l="Location"
                                          v={activityDetails?.location_name || "-"}
                                       />

                                       <DetailEntry
                                          l="Operator"
                                          v={activityDetails?.finger_dab_operator_name || "-"}
                                       />

                                       <DetailEntry
                                          l="Dabbed Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.start_date_time,
                                             true
                                          )}
                                       />

                                       <DetailEntry
                                          l="Monitoring Option"
                                          v={activityDetails?.finger_dab_option_name || "-"}
                                       />
                                    </>
                                 )}

                                 {activityType === "Surface Monitoring" && (
                                    <>
                                       <DetailEntry
                                          l="Location"
                                          v={activityDetails?.location_name || "-"}
                                       />

                                       <DetailEntry
                                          l="Start Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.start_date_time,
                                             true
                                          )}
                                       />
                                    </>
                                 )}

                                 {activityType === "Surface Monitoring Swab" && (
                                    <>
                                       <DetailEntry
                                          l="Location"
                                          v={activityDetails?.location || "-"}
                                       />

                                       <DetailEntry
                                          l="Test Tube"
                                          v={activityDetails?.test_tube_number || "-"}
                                       />

                                       <DetailEntry
                                          l="Swab Stick"
                                          v={activityDetails?.swab_stick_number || "-"}
                                       />

                                       <DetailEntry
                                          l="Operator"
                                          v={activityDetails?.started_operator_name || "-"}
                                       />

                                       <DetailEntry
                                          l="Start Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.start_date_time,
                                             true
                                          )}
                                       />
                                    </>
                                 )}

                                 {activityType === "Raw Material Test" && (
                                    <>
                                       <DetailEntry
                                          l="Material Type"
                                          v={activityDetails?.material_type_name || "-"}
                                       />

                                       <DetailEntry
                                          l="Conducted By"
                                          v={`${activityDetails?.started_by_user_firstname || "-"} ${activityDetails?.started_by_user_lastname || "-"
                                             }`}
                                       />

                                       <DetailEntry
                                          l="Test Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.start_date_time,
                                             true
                                          )}
                                       />
                                    </>
                                 )}

                                 {activityType === "Contact Plate Monitoring" && (
                                    <>
                                       <DetailEntry
                                          l="Sampling Type"
                                          v={activityDetails?.test_type_name || "-"}
                                       />

                                       <DetailEntry
                                          l="Sampled By"
                                          v={`${activityDetails?.started_by_user_firstname || "-"} ${activityDetails?.started_by_user_lastname || "-"
                                             }`}
                                       />

                                       <DetailEntry
                                          l="Sampled Date"
                                          v={helperFunctions.formatDate(
                                             activityDetails?.start_date_time,
                                             true
                                          )}
                                       />

                                       <DetailEntry l="Plate No" v={plate?.serial_number || "-"} />
                                       <DetailEntry l="Batch No" v={plate?.batch_number || "-"} />
                                       <DetailEntry l="Area" v={plate?.area_name || "-"} />
                                    </>
                                 )}

                              </div>
                           </div>

                           {/* 2. Incubation Summary */}
                           <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-6">
                              <div className="flex items-center justify-between border-b border-slate-50 pb-1">
                                 <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] flex items-center gap-3">
                                    <LuThermometer className="w-4 h-4 text-orange-500" /> Phase 02: Incubation Lifecycle
                                 </h3>
                              </div>
                              <div className="overflow-x-auto rounded-3xl border border-slate-50">
                                 <table className="w-full text-left border-collapse">
                                    <thead>
                                       <tr className="text-[9px] font-black text-slate-400 uppercase tracking-widest bg-slate-50/50">
                                          <th className="pl-6 py-2">Cycle</th>
                                          <th className="py-2">Incubator</th>
                                          <th className="py-2">Duration</th>
                                          <th className="py-2">Timeframes</th>
                                          <th className="py-2 pr-6 text-right">Status</th>
                                       </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-50">
                                       {incubations.length > 0 ? (
                                          incubations.map((inc: any, i: any) => (
                                             <tr key={i} className="text-[11px] font-bold group hover:bg-slate-50/50 transition-colors">
                                                <td className="pl-6 py-2 text-slate-400">0{inc.cycle}</td>
                                                <td className="py-2 text-slate-800">{inc.incubator}</td>
                                                <td className="py-2 text-blue-600">{inc.duration}</td>
                                                <td className="py-2">
                                                   <div className="flex flex-col text-[10px] text-slate-400">
                                                      <span>S: {helperFunctions.formatDate(inc.start, true)}</span>
                                                      <span>E: {helperFunctions.formatDate(inc.end, true)}</span>
                                                   </div>
                                                </td>
                                                <td className="py-2 pr-6 text-right">
                                                   <span className={`px-2 py-0.5 rounded-lg text-[9px] font-black uppercase border 
                                             ${inc.status === 'Completed' ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : 'bg-blue-50 text-blue-600 border-blue-100'}`}>
                                                      {inc.status}
                                                   </span>
                                                </td>
                                             </tr>
                                          ))
                                       ) : (
                                          <tr>
                                             <td
                                                colSpan={5}
                                                className="text-center py-8 text-slate-400"
                                             >
                                                No Incubation Records Found
                                             </td>
                                          </tr>
                                       )}
                                    </tbody>
                                 </table>
                              </div>
                           </div>

                           {/* 3. Lab Test Summary */}
                           <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-6">
                              <h3 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.25em] border-b border-slate-50 pb-1">
                                 <LuBeaker className="w-4 h-4 text-emerald-500" /> Phase 03: Laboratory Testing
                              </h3>
                              <div className="space-y-4">
                                 {labTests.length > 0 ? (
                                    labTests.map((test: any, i: any) => (
                                       <div
                                          key={i}
                                          className="bg-slate-50/50 p-6 rounded-[2rem] border border-slate-100 flex flex-col md:flex-row md:items-center justify-between gap-6"
                                       >
                                          <div className="flex items-center gap-6">
                                             <div className="w-10 h-10 rounded-xl bg-white border border-slate-200 flex items-center justify-center text-blue-500">
                                                <LuFileText className="w-5 h-5" />
                                             </div>

                                             <div>
                                                <p className="text-[10px] font-black text-slate-800 uppercase">
                                                   {test.testNo}
                                                </p>

                                                <p className="text-[9px] font-bold text-slate-400">
                                                   Analyst: {test.analyst || "-"}
                                                </p>
                                             </div>
                                          </div>

                                          <div className="flex-1 grid grid-cols-2 gap-6 px-4">
                                             <DetailEntrySmall
                                                l="Capture Date"
                                                v={helperFunctions.formatDate(test.timestamp, true)}
                                             />

                                             <DetailEntrySmall
                                                l="Remarks"
                                                v={test.remarks || "-"}
                                             />
                                          </div>

                                          <div className="text-right">
                                             <p className="text-[9px] font-black text-slate-400 uppercase">
                                                Colony Count
                                             </p>

                                             <p className="text-3xl font-black text-emerald-400">
                                                {test.count}
                                                <span className="text-[10px] text-slate-300">
                                                   {" "}
                                                   CFU
                                                </span>
                                             </p>
                                          </div>
                                       </div>
                                    ))
                                 ) : (
                                    <div className="text-center py-6 text-slate-400">
                                       No Lab Tests Available
                                    </div>
                                 )}
                              </div>
                           </div>

                           {/* Audit Trail Section */}
                           <AuditTrail plate={selectedPlateData} />
                        </div>

                        <div className="xl:col-span-4 space-y-6">
                           {/* 4. Approval Summary */}
                           <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-6">
                              <h3 className="text-[10px] font-black text-slate-400 uppercase border-b border-slate-50 pb-1 flex items-center gap-2">
                                 <LuShieldCheck className="w-4 h-4 text-blue-500" /> Phase 04: Approval Summary
                              </h3>
                              <div className="space-y-4">
                                 <SummaryItem
                                    l="Approved By"
                                    v={latestApproval?.approver_name || "-"}
                                 />

                                 <SummaryItem
                                    l="Approval Time"
                                    v={helperFunctions.formatDate(latestApproval?.approved_date, true)}
                                 />

                                 <SummaryItem
                                    l="Status"
                                    v={plate?.plate_status || "-"}
                                    isBadge
                                    color={
                                       plate?.plate_status === "LAB APPROVED"
                                          ? "bg-emerald-50 text-emerald-600 border-emerald-100"
                                          : "bg-amber-50 text-amber-600 border-amber-100"
                                    }
                                 />

                                 <SummaryItem
                                    l="Remarks"
                                    v={latestApproval?.approver_remarks || "-"}
                                 />
                              </div>
                           </div>

                           {/* 5. Environmental Flora Summary */}
                           {/* {flora && ( */}
                              <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-6">
                                 <h3 className="text-[10px] font-black text-slate-400 uppercase border-b border-slate-50 pb-1 flex items-center gap-2">
                                    <LuDna className="w-4 h-4 text-purple-500" /> Phase 05: Environmental Flora
                                 </h3>
                                 <div className="space-y-4">
                                    <SummaryItem
                                       l="Flora Required"
                                       v={selectedPlateData?.flora_required === "1" ? "YES" : "NO"}
                                    />

                                    <SummaryItem
                                       l="Flora Status"
                                       v={
                                          !flora
                                             ? "NOT RECORDED"
                                             : flora.flora_status === "36"
                                                ? "APPROVED"
                                                : flora.flora_status === "37"
                                                   ? "REJECTED"
                                                   : "COMPLETED"
                                       }
                                       isBadge
                                    />

                                    <SummaryItem
                                       l="Detected Genus"
                                       v={flora?.genus_name || "-"}
                                    />

                                    <SummaryItem
                                       l="Species"
                                       v={flora?.species_name || "-"}
                                    />

                                    <SummaryItem
                                       l="Reference Plate"
                                       v={selectedPlateData?.serial_number || "-"}
                                    />
                                 </div>
                              </div>
                           {/* )} */}

                           {/* 6. Autoclave Summary */}
                           <div className="bg-white p-8 rounded-[2.5rem] border border-slate-200/60 shadow-sm space-y-6">
                              <h3 className="text-[10px] font-black text-slate-400 uppercase border-b border-slate-50 pb-1 flex items-center gap-2">
                                 <LuFlame className="w-4 h-4 text-rose-500" /> Phase 06: Final Disposition
                              </h3>
                              <div className="space-y-4">
                                 <SummaryItem
                                    l="Equipment"
                                    v={autoclave?.location_name || "-"}
                                 />
                                 <SummaryItem
                                    l="Processing By"
                                    v={
                                       autoclave?.started_by_user_firstname
                                          ? `${autoclave.started_by_user_firstname} ${autoclave.started_by_user_lastname || ""}`.trim()
                                          : "-"
                                    }
                                 />
                                 <SummaryItem
                                    l="Cycle Date"
                                    v={
                                       autoclave?.start_time
                                          ? helperFunctions.formatDate(autoclave.start_time, true)
                                          : "-"
                                    }
                                 />
                                 <SummaryItem
                                    l="Cycle Status"
                                    v={
                                       autoclave
                                          ? autoclave.autoclave_status_name || "COMPLETED"
                                          : "NOT STARTED"
                                    }
                                    isBadge
                                 />
                              </div>
                           </div>

                           {/* Final Assessment Panel */}
                           <div className="bg-[#0F172A] p-8 rounded-[3rem] text-white space-y-8 shadow-2xl shadow-slate-900/40 relative overflow-hidden group">
                              <div className="absolute top-0 right-0 p-8 opacity-5 -rotate-12 scale-150 transition-transform group-hover:scale-[1.6] duration-1000">
                                 <LuShieldCheck className="w-48 h-48" />
                              </div>

                              <div className="space-y-5 relative z-10">
                                 <h3 className="text-[10px] font-black text-slate-500 uppercase tracking-[0.3em]">Final Assessment Panel</h3>
                                 <div className="grid grid-cols-3 gap-6 items-end">
                                    <div className="space-y-1">
                                       <p className="text-[8px] font-black text-slate-500 uppercase tracking-widest leading-none">CFU Count</p>
                                       <p className="text-4xl font-black text-emerald-400 tracking-tighter">
                                          {lab?.colony_count ?? 0}
                                       </p>
                                    </div>
                                    <div className="space-y-1">
                                       <p className="text-[8px] font-black text-slate-500 uppercase tracking-widest leading-none">Alert Limit</p>
                                       <p className="text-2xl font-black text-amber-500/80">
                                          {lab?.alert_limit ?? "-"}
                                       </p>
                                    </div>
                                    <div className="space-y-1">
                                       <p className="text-[8px] font-black text-slate-500 uppercase tracking-widest leading-none">Action Limit</p>
                                       <p className="text-2xl font-black text-rose-500/80">
                                          {lab?.action_limit ?? "-"}
                                       </p>
                                    </div>
                                 </div>
                              </div>

                              <div className="pt-6 space-y-5 border-t border-white/5 relative z-10">
                                 {/* Classification */}
                                 <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                    <span>Classification</span>
                                    {latestLab ? (
                                       <span
                                          className={`px-3 py-1 rounded-full border text-[10px] font-black uppercase ${latestLab.with_in_range === true || latestLab.with_in_range === "true"
                                             ? "text-emerald-400 bg-emerald-500/10 border-emerald-500/20"
                                             : "text-rose-400 bg-rose-500/10 border-rose-500/20"
                                             }`}
                                       >
                                          {latestLab.with_in_range === true || latestLab.with_in_range === "true"
                                             ? "WITHIN LIMIT"
                                             : "EXCEEDS LIMIT"}
                                       </span>
                                    ) : (
                                       <span className="text-slate-500">PENDING</span>
                                    )}
                                 </div>

                                 {/* Flora Outcome */}
                                 <div className="flex justify-between items-center text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                                    <span>Flora Outcome</span>
                                    <span
                                       className={`font-black uppercase ${!flora
                                          ? "text-slate-500"
                                          : flora.flora_status === "36"
                                             ? "text-emerald-400"
                                             : flora.flora_status === "37"
                                                ? "text-rose-400"
                                                : "text-slate-300"
                                          }`}
                                    >
                                       {!flora
                                          ? "NOT RECORDED"
                                          : flora.flora_status === "36"
                                             ? "APPROVED"
                                             : flora.flora_status === "37"
                                                ? "REJECTED"
                                                : "COMPLETED"}
                                    </span>
                                 </div>

                                 {/* Operational State */}
                                 <div className="bg-white/5 p-5 rounded-3xl border border-white/10 flex items-center justify-between transition-all">
                                    <div className="space-y-1.5">
                                       <p className="text-[9px] font-black text-slate-500 uppercase tracking-widest">Operational State</p>
                                       <div className="flex items-center gap-3">
                                          <div
                                             className={`w-2.5 h-2.5 rounded-full animate-pulse shadow-[0_0_8px_rgba(245,158,11,0.5)] ${selectedPlateData?.plate_status?.toLowerCase().includes("autoclave") ||
                                                selectedPlateData?.plate_status?.toLowerCase().includes("approved")
                                                ? "bg-emerald-500"
                                                : selectedPlateData?.plate_status?.toLowerCase().includes("incubat")
                                                   ? "bg-amber-500"
                                                   : "bg-blue-500"
                                                }`}
                                          />
                                          <p className="text-base font-black text-white italic tracking-tight uppercase">
                                             {selectedPlateData?.plate_status || "PENDING"}
                                          </p>
                                       </div>
                                    </div>
                                    <div
                                       className={`p-3 rounded-2xl ${selectedPlateData?.plate_status?.toLowerCase().includes("autoclave") ||
                                          selectedPlateData?.plate_status?.toLowerCase().includes("approved")
                                          ? "bg-emerald-500/20 text-emerald-500"
                                          : selectedPlateData?.plate_status?.toLowerCase().includes("incubat")
                                             ? "bg-amber-500/20 text-amber-500"
                                             : "bg-blue-500/20 text-blue-400"
                                          }`}
                                    >
                                       <LuClock className="w-8 h-8" />
                                    </div>
                                 </div>
                              </div>
                           </div>

                        </div>
                     </div>
                  </div>
               )}
               {/* </AnimatePresence> */}
            </div>
         </div>
      </div>
   );
};

// Reusable UI Components
const KpiCard = ({ label, val, color }: { label: string, val: any, color: string, key?: any }) => (
   <div className="bg-white p-3 rounded-[1.75rem] border border-slate-200/60 shadow-sm flex flex-col justify-between hover:border-blue-200 transition-all">
      <span className="text-[10px] font-black text-slate-500 tracking-[0.2em] uppercase mb-1">{label}</span>
      <div className="flex items-center gap-2.5">
         <div className={`w-1.5 h-4 rounded-full bg-${color}-500 shrink-0`} />
         <span className="text-[13px] font-black text-slate-800 tracking-tight truncate leading-tight">{val}</span>
      </div>
   </div>
);

const SummaryItem = ({ l, v, isBadge, isAlert }: any) => (
   <div className="flex justify-between items-center text-[11px]">
      <span className="font-bold text-slate-500 uppercase text-[9px] tracking-widest">{l}</span>
      {isBadge ? (
         <span className="px-2 py-0.5 rounded-md bg-slate-50 text-slate-500 border border-slate-100 font-black uppercase text-[9px]">{v}</span>
      ) : (
         <span className={`font-black tracking-tight ${isAlert ? 'text-amber-500 underline underline-offset-4 decoration-dotted' : 'text-slate-800'}`}>{v}</span>
      )}
   </div>
);

const SummaryItemLight = ({ l, v }: any) => (
   <div className="flex justify-between items-center text-[11px]">
      <span className="font-bold text-slate-500 uppercase text-[9px] tracking-widest">{l}</span>
      <span className="font-black text-white tracking-tight uppercase">{v}</span>
   </div>
);

const HealthIndicator = ({ l, v, color }: any) => (
   <div className="space-y-1">
      <p className="text-[8px] font-bold text-slate-500 uppercase">{l}</p>
      <div className="flex items-center gap-2">
         <div className={`w-1.5 h-1.5 rounded-full bg-${color}-500`} />
         <p className="text-[10px] font-black text-white uppercase">{v}</p>
      </div>
   </div>
);

const StatusLegendDot = ({ l, c }: any) => (
   <div className="flex items-center gap-2">
      <div className={`w-1.5 h-1.5 rounded-full ${c}`} />
      <span className="text-[10px] font-black text-slate-500 uppercase tracking-widest">{l}</span>
   </div>
);

const WorkflowNodeItem = ({ node, idx }: any) => {
   const getStyles = () => {
      switch (node.status) {
         case 'Completed': return 'bg-emerald-500 border-emerald-200 text-white';
         case 'In Progress': return 'bg-blue-500 border-blue-200 text-white animate-pulse';
         case 'Rejected': return 'bg-rose-500 border-rose-200 text-white';
         case 'Skipped': return 'bg-orange-500 border-orange-200 text-white';
         default: return 'bg-slate-100 border-slate-200 text-slate-400';
      }
   };

   return (
      <div className="flex flex-col items-center group w-36 shrink-0 relative">
         <div className={`w-12 h-12 rounded-full border-4 shadow-md flex items-center justify-center transition-all duration-300 relative z-20 ${getStyles()}`}>
            {node.status === 'Completed' ? <LuCheckCircle2 className="w-6 h-6" /> :
               node.status === 'In Progress' ? <LuClock className="w-6 h-6" /> :
                  node.status === 'Rejected' ? <LuAlertTriangle className="w-6 h-6" /> :
                     <LuCheckCircle className="w-6 h-6" />}
         </div>
         <div className="mt-5 text-center space-y-1.5 w-full">
            <p className={`text-[12px] font-black tracking-[0.1em] uppercase ${node.status === 'Pending' ? 'text-slate-500' : 'text-slate-800'}`}>
               {node.label}
            </p>
            {node.timestamp && (
               <div className="text-[10px] font-bold text-slate-500 flex flex-col">
                  <span>{helperFunctions.formatDate(node.timestamp, true)}</span>
                  <span className={`${node.status === 'Completed' ? 'text-emerald-500' : 'text-blue-500'} font-black`}>{node.result}</span>
               </div>
            )}
         </div>
      </div>
   );
};
const DetailEntrySmall = ({ l, v, isBadge }: any) => (
   <div>
      <p className="text-[8px] font-black text-slate-500 uppercase tracking-widest mb-1">{l}</p>
      {isBadge ? (
         <span className="text-[9px] font-black text-emerald-600 uppercase bg-white border border-emerald-100 px-2 rounded-md">{v}</span>
      ) : (
         <p className="text-[10px] font-bold text-slate-600 truncate">{v}</p>
      )}
   </div>
);

const AssessmentKpi = ({ l, v, c }: any) => (
   <div className="space-y-1">
      <p className="text-[8px] font-black text-slate-500 uppercase">{l}</p>
      <p className={`text-2xl font-black ${c} tracking-tighter`}>{v}</p>
   </div>
);
const DetailEntry = ({ l, v }: { l: string, v: string }) => (
   <div className="space-y-1.5 group/entry">
      <p className="text-[9px] font-black text-slate-500 uppercase tracking-widest group-hover/entry:text-blue-400 transition-colors">{l}</p>
      <p className="text-[11px] font-black text-slate-700 border-b border-slate-50 pb-2 group-hover/entry:border-blue-50 transition-colors">{v}</p>
   </div>
);

const CompactHealthBadge = ({ l, v, c }: { l: string, v?: string, c: string }) => (
   <div className={`px-3 py-1.5 rounded-xl border border-white/10 flex items-center gap-2 ${c}`}>
      <div className="w-1.5 h-1.5 rounded-full bg-current" />
      <span className="text-[9px] font-black uppercase tracking-widest leading-none">{l} {v && `: ${v}`}</span>
   </div>
);

const AuditTrail = ({ plate }: { plate?: any }) => {
   const [isOpen, setIsOpen] = useState(false);

   // Build events from real plate data
   const events: { t: string; e: string; u: string }[] = [];

   const fmt = (d?: string) =>
      d ? new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '-';

   const activityDetail =
      plate?.glove_monitoring_details?.[0] ||
      plate?.exposure_details?.[0] ||
      plate?.anaerobic_details?.[0] ||
      plate?.nitrogen_monitoring_details?.[0] ||
      plate?.compressed_air_monitoring_details?.[0] ||
      plate?.finger_dab_details?.[0] ||
      plate?.surface_monitoring_details?.[0] ||
      plate?.surface_monitoring_swab_details?.[0] ||
      plate?.raw_material_test_details?.[0] ||
      plate?.plate_sampling_details?.[0];

   if (activityDetail?.start_date_time) {
      const name = activityDetail.created_by_first_name
         ? `${activityDetail.created_by_first_name} ${activityDetail.created_by_last_name || ''}`.trim()
         : activityDetail.started_by_user_name || 'System';
      events.push({ t: fmt(activityDetail.start_date_time), e: 'Activity Started', u: name });
   }
   if (activityDetail?.end_date_time) {
      events.push({ t: fmt(activityDetail.end_date_time), e: 'Activity Completed & Collected', u: 'System' });
   }

   plate?.incubation_details?.forEach((inc: any, i: number) => {
      if (inc.start_date_time) {
         events.push({ t: fmt(inc.start_date_time), e: `Incubation Cycle ${i + 1} Started`, u: 'System' });
      }
      if (inc.end_date_time) {
         events.push({ t: fmt(inc.end_date_time), e: `Incubation Cycle ${i + 1} Completed`, u: 'System' });
      }
   });

   plate?.lab_details?.forEach((lab: any, i: number) => {
      if (lab.completed_date_time) {
         const analyst = lab.completed_by_user_name || 'Lab Analyst';
         events.push({
            t: fmt(lab.completed_date_time),
            e: `Lab Test ${i + 1} Completed — ${lab.colony_count ?? 0} CFU`,
            u: analyst,
         });
      }
      if (lab.approved_date) {
         const approver = lab.approver_name || 'Approver';
         events.push({ t: fmt(lab.approved_date), e: `Lab Test ${i + 1} Approved`, u: approver });
      }
   });

   plate?.flora_details?.forEach((fl: any) => {
      if (fl.created_date) {
         events.push({ t: fmt(fl.created_date), e: `Environmental Flora Recorded — ${fl.genus_name || '-'}`, u: fl.created_by_name || 'System' });
      }
   });

   plate?.autoclave_details?.forEach((ac: any) => {
      if (ac.created_date_time) {
         events.push({ t: fmt(ac.created_date_time), e: 'Autoclave Cycle Completed', u: ac.created_by_name || 'System' });
      }
   });

   // Sort chronologically
   events.sort((a, b) => new Date(a.t).getTime() - new Date(b.t).getTime());

   return (
      <div className="bg-white rounded-[2.5rem] border border-slate-200/60 shadow-sm overflow-hidden transition-all">
         <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full px-8 py-5 flex items-center justify-between border border-slate-200/60 hover:bg-slate-50 transition-colors"
         >
            <div className="flex items-center gap-3">
               <LuHistory className="w-4 h-4 text-slate-500" />
               <span className="text-[10px] font-black text-slate-500 uppercase tracking-[0.25em]">Traceability Audit Trail</span>
            </div>
            <LuArrowDown className={`w-4 h-4 text-slate-300 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
         </button>
         {isOpen && (
            <div>
               <div className="space-y-4 pt-4 border-t border-slate-50 ps-2">
                  {events.length > 0 ? events.map((ev, i) => (
                     <div key={i} className="flex gap-6 group">
                        <div className="w-[120px] shrink-0">
                           <p className="text-[9px] font-black text-slate-300 group-hover:text-blue-400 transition-colors">{ev.t}</p>
                        </div>
                        <div className="relative flex-1 pb-4">
                           {i < events.length - 1 && <div className="absolute left-[-25px] top-2 bottom-0 w-px bg-slate-100" />}
                           <div className="absolute left-[-28px] top-1 w-1.5 h-1.5 rounded-full bg-slate-200 group-hover:bg-blue-500 transition-colors" />
                           <p className="text-[11px] font-black text-slate-700 leading-none mb-1">{ev.e}</p>
                           <p className="text-[9px] font-bold text-slate-500 uppercase tracking-widest">{ev.u}</p>
                        </div>
                     </div>
                  )) : (
                     <p className="text-center text-slate-400 text-[10px] py-6">No audit events found.</p>
                  )}
               </div>
            </div>
         )}
      </div>
   );
};

export default PlateActivityReport3;
